import axios from '@_system/axios/axios.js'
export default {
	path: '/invoiceoutput',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateorder(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateorder/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	splitorder(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/splitorder/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	joinorder(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/joinorder/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	reissue(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reissue/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uninvoice(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uninvoice/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	getbyinvoicestatus(status, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getbyinvoicestatus/' + status, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	drop(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/drop/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	reversal(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/reversal/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	remarkonline(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/remarkonline', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	download(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/download', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	listTrades(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listTrades/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	searchinvoicetaxid(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/searchinvoicetaxid/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	sendemail(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendemail/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uploadfile(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uploadfile/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/invoice.invoiceoutput', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	import(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	export (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
}
